import { Route, Routes, Navigate } from 'react-router-dom';
import { Layout } from './components/Layout';
import { ProtectedRoute } from './components/ProtectedRoute';
import { AdminRoute } from './components/AdminRoute';
import AdminLayout from './pages/admin/AdminLayout';
import AdminOverviewPage from './pages/admin/AdminOverviewPage';
import AdminReviewPage from './pages/admin/AdminReviewPage';
import AdminProposalsPage from './pages/admin/AdminProposalsPage';
import AdminCurationPage from './pages/admin/AdminCurationPage';
import AdminPricingPage from './pages/admin/AdminPricingPage';
import AdminCredentialsPage from './pages/admin/AdminCredentialsPage';
import AdminJobsPage from './pages/admin/AdminJobsPage';
import AdminCostPage from './pages/admin/AdminCostPage';
import AdminOpsReportPage from './pages/admin/AdminOpsReportPage';
import AdminReportsPage from './pages/admin/AdminReportsPage';
import AdminInstitutionsPage from './pages/admin/AdminInstitutionsPage';
import AdminGamificationPage from './pages/admin/AdminGamificationPage';
import AdminCertProfilesPage from './pages/admin/AdminCertProfilesPage';
import AdminStandardsPage from './pages/admin/AdminStandardsPage';
import LibraryPage from './pages/LibraryPage';
import BookDetailPage from './pages/BookDetailPage';
import MindmapPage from './pages/MindmapPage';
import QuizPage from './pages/QuizPage';
import ReaderPage from './pages/ReaderPage';
import ProposePage from './pages/ProposePage';
import ReportPage from './pages/ReportPage';
import LarcPage from './pages/LarcPage';
import VaultPage from './pages/VaultPage';
import VerifyPage from './pages/VerifyPage';
import NotFoundPage from './pages/NotFoundPage';
import CredentialsPage from './pages/CredentialsPage';
import AchievementsPage from './pages/AchievementsPage';
import LoginPage from './pages/LoginPage';
import UploadPage from './pages/UploadPage';
import JobPage from './pages/JobPage';

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Navigate to="/library" replace />} />
        <Route path="/library" element={<LibraryPage />} />
        <Route path="/larc" element={<LarcPage />} />
        <Route path="/verify" element={<VerifyPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/upload" element={<ProtectedRoute><UploadPage /></ProtectedRoute>} />
        <Route path="/jobs/:jobId" element={<ProtectedRoute><JobPage /></ProtectedRoute>} />
        <Route path="/books/:bookId" element={<ProtectedRoute><BookDetailPage /></ProtectedRoute>} />
        <Route path="/books/:bookId/map" element={<ProtectedRoute><MindmapPage /></ProtectedRoute>} />
        <Route path="/books/:bookId/quiz" element={<ProtectedRoute><QuizPage /></ProtectedRoute>} />
        <Route path="/books/:bookId/read" element={<ProtectedRoute><ReaderPage /></ProtectedRoute>} />
        <Route path="/books/:bookId/propose" element={<ProtectedRoute><ProposePage /></ProtectedRoute>} />
        <Route path="/books/:bookId/report" element={<ProtectedRoute><ReportPage /></ProtectedRoute>} />
        <Route path="/credentials" element={<ProtectedRoute><CredentialsPage /></ProtectedRoute>} />
        <Route path="/achievements" element={<ProtectedRoute><AchievementsPage /></ProtectedRoute>} />
        <Route path="/vault" element={<ProtectedRoute><VaultPage /></ProtectedRoute>} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>

      {/* Admin console — 자체 shell(AdminLayout) + AdminRoute 게이트 */}
      <Route path="/admin" element={<AdminRoute><AdminLayout /></AdminRoute>}>
        <Route index element={<AdminOverviewPage />} />
        <Route path="review" element={<AdminReviewPage />} />
        <Route path="proposals" element={<AdminProposalsPage />} />
        <Route path="curation" element={<AdminCurationPage />} />
        <Route path="reports" element={<AdminReportsPage />} />
        <Route path="jobs" element={<AdminJobsPage />} />
        <Route path="cost" element={<AdminCostPage />} />
        <Route path="ops-report" element={<AdminOpsReportPage />} />
        <Route path="pricing" element={<AdminPricingPage />} />
        <Route path="credentials" element={<AdminCredentialsPage />} />
        <Route path="institutions" element={<AdminInstitutionsPage />} />
        <Route path="gamification" element={<AdminGamificationPage />} />
        <Route path="cert-profiles" element={<AdminCertProfilesPage />} />
        <Route path="standards" element={<AdminStandardsPage />} />
      </Route>
    </Routes>
  );
}
